import React from 'react';
import CommonField from './CommonField.jsx';
import TextInput from '../../../../common/TextInput.jsx';
import get from 'lodash/get';

const TextSetting = (props) => {
  const { attr, label, prefix = '', selectedObject, setAttribute, disabled = false } = props;
  const fullAttr = [prefix, attr].filter(Boolean).join('.');
  return (
    <CommonField label={label} {...props} attr={fullAttr}>
      <TextInput
        value={get(selectedObject, fullAttr)}
        afterChange={v => setAttribute(fullAttr, v ? v : undefined)}
        disabled={disabled}
      />
    </CommonField>
  )
}

export default TextSetting;